"use client";

import { useState, useTransition } from "react";

import { ChevronDownCircle } from "lucide-react";

import { Button } from "@kit/ui/button";

import { voteIssueAction } from "../lib/server/server-actions";
import { UpVoteButton } from "./upvote-button";

export function DownVoteButton(props: {
  votes: number;
  disabled: boolean;
  issueId: string;
}) {
  const [pending, startTransition] = useTransition();
  const [downvoted, setDownvoted] = useState(false);

  if (downvoted) {
    return <UpVoteButton {...props} votes={props.votes - 1} />;
  }

  return (
    <Button
      disabled={props.disabled || pending}
      variant={"outline"}
      size={"sm"}
      className={
        "flex items-center space-x-1 border-l-4 border-l-orange-500 px-2 font-semibold"
      }
      onClick={() => {
        startTransition(async () => {
          await voteIssueAction({
            issueId: props.issueId,
            direction: "down",
          });

          setDownvoted(true);
        });
      }}
    >
      <ChevronDownCircle
        className={"fill-primary text-primary-foreground h-5"}
      />

      <span>{props.votes}</span>
    </Button>
  );
}
